import Layout from '../../../config/Layout';

export default {
    container: {
        flex: 1,
        paddingTop: Layout.statusBar,
        flexDirection: 'column-reverse'
    },

    content: {
        flex: 1
    }
};
